import axios from "axios";
import configs from "../../../../configurations/configs";
import router from "@/configurations/router";

const IP = configs.SERVER_IP;

const state = {
  orders: [],
  outbox: [],
  track: {},
  calculation: {},
  response: {},
};

const getters = {
  getOrders: (state) => state.orders,
  getTracking: (state) => state.track,
  getCalculation: (state) => state.calculation,
  getRequestResponse: (state) => state.response,
  getTrackingRequestError: (state) => state.response,
};

const actions = {
  async fetchOrders({ commit }, data) {
    await axios
      .post(IP + "/client/mail/orders", data)
      .then((response) => {
        //console.log(response.data)
        commit("setOrdersResponse", response);
      })
      .catch((error) => {
        console.log(error);
      });
  },

  async calculate({ commit }, data) {
    await axios
      .post(IP + "/client/mail/get_charge", data)
      .then((response) => {
        console.log(response.data);
        commit("setCalculatorResponse", response);
      })
      .catch((error) => {
        console.log(error);
      });
  },

  async makeDeliveryRequest({ commit }, data) {
    await axios
      .post(IP + "/client/mail/request", data)
      .then((response) => {
        commit("setRequestResponse", response);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  async makeTrackingRequest({ commit }, data) {
    await axios
      .post(IP + "/client/mail/track", data)
      .then((response) => {
        commit("setTrackingResponse", response);
      })
      .catch((error) => {
        console.log(error.response.data);
        commit("setTrackingError", error.response.data);
      });
  },
};

const mutations = {
  setOrdersResponse: (state, response) => {
    state.orders = response.data.data;
  },
  setRequestResponse: (state, response) => {
    state.response = response.data;
    router.push("/dashboard/delivery").catch((err) => {
      console.log(err);
    });
    router.go();
    alert("Delivery Request has been sent");
  },
  setTrackingResponse: (state, response) => {
    state.track = response.data.data;
  },
  setTrackingError: (state, error) => {
    state.response = error;
  },
  setCalculatorResponse: (state, response) => {
    state.calculation = response.data;
  },
};
export default {
  state,
  getters,
  actions,
  mutations,
};
